import { useTranslation } from 'react-i18next';

import { TableHead, TableHeadCell, TableHeadCellProps, TableHeadRow } from '@client/toolkit';

export interface EconomyTableColumn {
  /** Names the column's label under `<section>.columns`. */
  key: string;
  /** Width hint; the standard table lays out on content, so this only steers it. */
  className?: string;
  align?: TableHeadCellProps['align'];
}

export interface EconomyTableHeadProps {
  /** i18n prefix of the owning table, e.g. `settings.groupAccounts`. */
  section: string;
  columns: readonly EconomyTableColumn[];
}

/** Header row of an account table, labelled from `<section>.columns.<key>`. */
export function EconomyTableHead({ section, columns }: EconomyTableHeadProps) {
  const { t } = useTranslation('economy');

  return (
    <TableHead>
      <TableHeadRow>
        {columns.map((column) => (
          <TableHeadCell key={column.key} className={column.className} align={column.align}>
            {t(`${section}.columns.${column.key}`)}
          </TableHeadCell>
        ))}
      </TableHeadRow>
    </TableHead>
  );
}

export default EconomyTableHead;
